const host=window.location.hostname
const apiurl="https://backend.mhuda.in"
// const apiurl="http://103.89.45.196:0778"
export {apiurl,host}